import {KTIcon} from '../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {Filter} from './Filter'

const ListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <Filter /> 
      <button type='button' className='btn btn-primary' onClick={openAddModal}>
        <KTIcon iconName='plus' className='fs-2' />
        Add New
      </button> 
    </div>
  )
}

export {ListToolbar}
